//hook
import { useState, useEffect } from "react";
import { useApi } from "../../hooks/useApi";

//image
import roomImage from "../../assets/images/home_image/room_1.jpg"

//css file
import style from "../Rooms/Rooms.module.css"

//mui
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import ReplayIcon from '@mui/icons-material/Replay';

//component
import AmenitiesDetailsCard from "../../Component/AmenitiesDetailsCard";
import Booking from "../../popup/Booking";

//tranlsate
import { useTranslation } from 'react-i18next';
import i18n from "../../translate/i18n";

//api
import { GetAllAmenities } from "../../api/amenities/GetAllAmenities";

//type
import { amenityType } from "../../api/amenities/type/AmenitiesType";

interface AmenitiesPageProps {
  bookingRequest: {cardId: number | null; open: boolean, type: string};
  setBookingRequest: (bookingRequest: {cardId: number | null; open: boolean , type: string}) => void
}
const AmenitiesPage = ({bookingRequest, setBookingRequest}:AmenitiesPageProps) => {
    const {t} = useTranslation()
    const [amenityData, setAmenitiesData] = useState<amenityType[]>([]);
  const {
    loading: amenitiesLoading,
    error: amenitiesError,
    HandlerApi: amenitiestApi
  } = useApi(GetAllAmenities, "GET");

  useEffect(() => {
    const fetchData = async () => {
      const amenities = await amenitiestApi();
      setAmenitiesData(amenities.data);
      };
    fetchData();
    }, []);
    return (
        <div className={`${i18n.language === "en" ? "font-palab" : "font-helvetica-arabic-bold"} text-primaryColor bg-[#EDEBDF]`}>
            <div className={`h-[500px] max-md:h-72 relative image ${style.image}`}>
                <img className="w-full h-full object-cover" src={roomImage} alt="no_photo"/>
                <p className="absolute top-1/2 left-1/2 transform -translate-x-1/2 translate-y-1/2 text-white md:text-2xl sm:text-sm max-sm:text-[13px]">{t("amenities")}</p>
            </div>
            <div dir={i18n.language === "en" ? "ltr" : "rtl"} className="py-10 ">
                <Box sx={{padding: {md: "40px", xs: "20px"}}} className="max-w-[1560px] m-auto gap-[10px] text-center">
                    <h2 className="sm:text-5xl max-sm:text-2xl mb-4 text-primaryColor">
                        {t("luxury_amenities")}
                    </h2>
                    <p className="max-w-[600px] mb-4 m-auto">{t("amenities_description")}</p>
                    <div>
                    {amenitiesLoading 
                    ? 
                    <div className='flex justify-center w-full'>
                        <CircularProgress/>
                    </div>
                    :
                    amenitiesError
                    ?
                    <div className='cursor-pointer flex justify-center w-full'>
                        <ReplayIcon onClick={amenitiestApi} className='!text-[40px]' />
                    </div>
                    :
                    <div className="grid md:grid-cols-3 grid-cols-1 gap-5">
                        {amenityData.map((element, index)=>{
                            return <AmenitiesDetailsCard key={index} element={element} setBookingRequest={setBookingRequest}/>
                        })}
                    </div>
                    }
                    </div>
                </Box>
                <Booking bookingRequest={bookingRequest} setBookingRequest={setBookingRequest}/>
            </div>
        </div>
    )
}

export default AmenitiesPage
